import { outwardCashReceiptAddApi } from "../../api/outwardCashReceipt/outwardCashReceiptAddApi"

type PayloadShape = Parameters<typeof outwardCashReceiptAddApi>[0]

export async function outwardCashReceiptAddService(payload: PayloadShape, token: string) {
	return await outwardCashReceiptAddApi(payload, token)
}
